import getSpamScenarioIdKey from '../utils/getSpamScenarioIdKey';
import getStore from '../store/store';
import { SpamScenarioId } from 'owa-junkmail-configuration';
import { SpamScenarioStore } from '../store/schema/SpamOptionStore';

export default function getSpamScenarioStore(scenarioId: SpamScenarioId): SpamScenarioStore {
    return getStore().spamStores.get(getSpamScenarioIdKey(scenarioId));
}
